// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 8594) return "static/chunks/8594-7130135e8b23f790.js";
	if (chunkId === 7581) return "static/chunks/7581-61361b657afd41d2.js";
	if (chunkId === 8137) return "static/chunks/8137-513a94ad60f9b221.js";
	if (chunkId === 3405) return "static/chunks/3405-0fa7ec0168ffc9f0.js";
	if (chunkId === 2943) return "static/chunks/2943-6468e0e7053a4c9c.js";
	if (chunkId === 777) return "static/chunks/777-4fe6d4aa796dc907.js";
	if (chunkId === 3156) return "static/chunks/3156-f3ee71cac87f7859.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"1b34c61698aab779","804":"792193c2d0a8497d","1117":"e2c68699c3b6135d","1673":"d64f8a5cdeca1035","2140":"f9b9c42e0937cb5a","4686":"115275b932ae91d1","5836":"c31d8bdceb64025e","9074":"4261191f198d2708","9249":"bdf1789c6a6cb2ae"}[chunkId] + ".js";
};